import { makeStyles } from 'tss-react/mui'

export const generalMobileStyles = makeStyles()(theme => ({
  divider: {
    backgroundColor: theme.colors.textButton,
    marginTop: '10px',
    marginBottom: '10px'
  },
  dividerAlt: {
    backgroundColor: theme.colors.textButton,
    marginTop: '-5px',
    marginBottom: '10px'
  },
  headerBottomSpace: {
    height: '5px'
  },
  notchCustom: {
    zoom: '85%'
  },
  closeButtonContainer: {
    width: '600px'
  },
  footerBottomSpace: {
    height: '350px'
  },
  phoneContainer: {
    width: '300px',
    height: '200px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'scale(0.8) translate(-50%, -50%)',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center'
  },
  sectionHeaderArrow: {
    fontSize: '16px',
    marginTop: '4px'
  },
  sectionHeader: {
    paddingTop: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  sectionHeaderTitle: {
    lineHeight: '15px',
    fontFamily: 'Rubik Bold',
    fontSize: '14px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical'
  },
  screenContainer: {
    marginTop: '55px',
    height: '88%'
  },
  elementsContainer: {
    '&::-webkit-scrollbar': {
      display: 'none'
    },
    scrollbarWidth: 'none',
    '-ms-overflow-style': 'none',
    paddingRight: '10px',
    paddingLeft: '10px',
    height: '99%',
    overflow: 'auto',
    marginTop: '6px',
    boxShadow:
      '0px 0px 2.10316px  rgba(0, 0, 0, 0.16), 0px 1.05158px 2.10316px rgba(0, 0, 0, 0.16)',
    borderRadius: '8.41263px 8.41263px 49px 49px'
  },
  collapsedDropDown: {
    height: 24,
    justifyContent: 'center',
    alignItems: 'center'
  },
  collapsedText: {
    textAlign: 'center',
    fontStyle: 'italic',
    fontSize: 12,
    fontWeight: '500',
    color: theme.colors.gray
  },
  closeButton: {
    ':hover': {
      background: theme.colors.white,
      border: `1px solid ${theme.colors.iconBlue}`
    },
    background: theme.colors.white,
    color: 'black',
    textTransform: 'none',
    letterSpacing: '0.16px',
    fontWeight: '700',
    lineHeight: '24px',
    fontSize: '16px',
    width: '105px',
    height: '59px'
  }
}))

export const elementContainer = makeStyles()(theme => ({
  shadow: {
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    padding: '10px 5px',
    borderRadius: '8px',
    background: theme.colors.white,
    overflow: 'visible'
  },
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    letterSpacing: '1px',
    fontSize: '10px',
    fontFamily: 'Rubik',
    color: 'black',
    fontWeight: '700',
    paddingRight: '5px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    display: 'flex'
  },
  icon: {
    fontSize: '10px',
    color: theme.colors.iconBlue,
    marginBottom: '2px'
  },
  required: {
    color: theme.colors.redError
  }
}))

export const textInputStyles = makeStyles()(theme => ({
  title: {
    fontSize: '18px',
    fontFamily: 'Rubik',
    color: 'black',
    fontWeight: '700',
    paddingRight: '5px'
  },
  textFieldStyles: {
    backgroundColor: 'transparent',
    '*.Mui-focused': {
      borderColor: 'transparent',
      outline: 'none'
    },
    '& .MuiFilledInput-root': {
      fontSize: '14px',
      background: theme.colors.white,
      paddingTop: '3px',
      paddingLeft: '0px'
    },
    '& .MuiFilledInput-root.Mui-disabled': {
      background: theme.colors.white
    },
    '& .MuiInputBase-root': {
      '& input': {
        WebkitBoxShadow: `0 0 0 1000px ${theme.colors.white} inset`
      }
    }
  },
  textFieldStylesAlt: {
    backgroundColor: 'transparent',
    '*.Mui-focused': {
      borderColor: 'transparent',
      outline: 'none'
    },
    '& .MuiFilledInput-root': {
      fontSize: '14px',
      background: theme.colors.white,
      paddingLeft: '0px'
    },
    '& .MuiFilledInput-root.Mui-disabled': {
      background: theme.colors.white
    },
    '& .MuiInputBase-root': {
      '& input': {
        WebkitBoxShadow: `0 0 0 1000px ${theme.colors.white} inset`
      }
    }
  }
}))

export const navigationBarStyles = makeStyles()(theme => ({
  allsetMessageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  textContainer: {
    width: '100%',
    paddingRight: '30px'
  },
  backIcon: {
    fontSize: '20px',
    paddingLeft: '15px',
    paddingTop: '8px'
  },
  secondaryContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    marginTop: '30px',
    paddingBottom: '5px',
    boxShadow: `0 3px 3px 1px ${theme.colors.gradient}`,
    height: '50px'
  },
  taskCounterText: {
    letterSpacing: '1px',
    textAlign: 'center',
    color: theme.colors.gray,
    fontWeight: '700',
    fontFamily: 'Rubik Bold',
    fontSize: '12px'
  },
  pendingTaskCounterText: {
    letterSpacing: '1px',
    textAlign: 'center',
    color: theme.colors.redError,
    fontWeight: '700',
    fontFamily: 'Rubik Bold',
    fontSize: '12px'
  },
  authorizationText: {
    letterSpacing: '1px',
    textAlign: 'center',
    color: theme.colors.gray,
    fontWeight: '700',
    fontFamily: 'Rubik Bold',
    fontSize: '12px'
  },
  serviceFormTitle: {
    fontWeight: '800',
    textAlign: 'center',
    fontFamily: 'Rubik Bold',
    fontSize: '10px',
    lineHeight: '13px',
    color: theme.colors.gray
  }
}))

export const checklistItemStyles = makeStyles()(theme => ({
  shadow: {
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    padding: '10px 5px',
    borderRadius: '8px',
    background: theme.colors.white
  },
  required: {
    color: theme.colors.redError
  },
  inconButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '30px',
    height: '30px'
  },
  icon: {
    color: theme.colors.iconBlue
  },
  iconRed: {
    color: theme.colors.red0
  },
  iconDisabled: {
    color: theme.colors.text
  },
  checkContainer: {
    border: `1px solid ${theme.colors.iconBlue}`,
    height: '30px',
    width: '30px',
    marginLeft: 8,
    alignSelf: 'center',
    backgroundColor: theme.colors.white,
    borderRadius: '8px',
    justifyContent: 'center',
    alignItems: 'center'
  },
  checkContainerDisabled: {
    border: `1px solid ${theme.colors.textGray}`,
    height: '30px',
    width: '30px',
    marginLeft: 8,
    alignSelf: 'center',
    backgroundColor: theme.colors.white,
    borderRadius: '8px',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '5px',
    paddingBottom: '5px'
  },
  boxesContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  boxHeader: {
    width: 30,
    marginLeft: 8
  },
  boxHeaderText: {
    color: theme.colors.loadingRing,
    fontSize: '8px',
    textAlign: 'center',
    fontWeight: '700',
    fontFamily: 'Rubik'
  }
}))

export const multiButtonSelectionStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingTop: '10px'
  },
  chipStyles: {
    '&.MuiChip-root:hover': {
      background: 'transparent'
    },
    paddingTop: '5px',
    paddingBottom: '5px',
    marginRight: '5px',
    marginBottom: '5px',
    fontSize: '10px',
    borderColor: theme.colors.iconBlue,
    color: theme.colors.iconBlue,
    fontWeight: '700',
    lineHeight: '30px',
    fontFamily: 'Rubik',
    minWidth: '111px',
    maxWidth: '100%'
  },
  disabledChipStyles: {
    '&.Mui-disabled': {
      opacity: 1
    },
    '&.MuiChip-root:hover': {
      background: 'transparent'
    },
    paddingTop: '5px',
    paddingBottom: '5px',
    marginRight: '5px',
    marginBottom: '5px',
    fontSize: '10px',
    borderColor: theme.colors.textGray,
    color: theme.colors.text,
    fontWeight: '700',
    lineHeight: '30px',
    fontFamily: 'Rubik',
    minWidth: '111px',
    maxWidth: '100%'
  },
  chipStylesSelected: {
    '&.Mui-disabled': {
      opacity: 1
    },
    '&.MuiChip-root:hover': {
      background: theme.colors.iconBlue
    },
    background: theme.colors.iconBlue,
    marginRight: '5px',
    marginBottom: '5px',
    fontSize: '10px',
    borderColor: theme.colors.iconBlue,
    color: theme.colors.white,
    fontWeight: '700',
    lineHeight: '30px',
    fontFamily: 'Rubik',
    minWidth: '111px',
    minHeight: '28px'
  },
  chipPreviewModeStyles: {
    '&.Mui-disabled': {
      opacity: 1
    },
    '&.MuiChip-root:hover': {
      background: theme.colors.text
    },
    background: theme.colors.text,
    marginRight: '5px',
    marginBottom: '5px',
    fontSize: '10px',
    borderColor: theme.colors.textGray,
    color: theme.colors.white,
    fontWeight: '700',
    lineHeight: '30px',
    fontFamily: 'Rubik',
    minWidth: '111px',
    minHeight: '28px'
  }
}))

export const dropDownSelectionStyles = makeStyles()(theme => ({
  optionContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: '5px',
    paddingBottom: '5px'
  },
  optionIcon: {
    fontSize: '12px',
    marginLeft: '5px'
  },
  optionText: {
    fontSize: '12px'
  },
  optionPressable: {
    width: '100%'
  },
  menuItems: {
    width: '297px',
    fontSize: '12px'
  },
  selectButtonAlt: {
    border: `1px solid ${theme.colors.iconBlue}`,
    width: '100%',
    paddingTop: '8px',
    paddingBottom: '8px',
    borderRadius: '8px'
  },
  buttonSelected: {
    textTransform: 'none',
    color: theme.colors.text
  },
  selectButtonText: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '10px',
    color: theme.colors.iconBlue
  },
  singleSelect: {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    borderWidth: '0px',
    marginTop: '10px',
    fontSize: '14px'
  },
  selectedPill: {
    fontSize: '12px',
    background: theme.colors.white,
    marginRight: '10px',
    paddingRight: '3px',
    paddingLeft: '3px',
    minWidth: '111px',
    minHeight: '28px',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  buttonText: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '16px',
    color: theme.colors.text
  },
  popUpButton: {
    border: `1px solid ${theme.colors.text}`,
    width: '85%',
    paddingTop: '10px',
    paddingBottom: '10px',
    borderRadius: '7px'
  },
  popUpButtonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px'
  },
  popUpList: {
    width: '100%',
    paddingLeft: '5px',
    paddingRight: '5px'
  },
  popUpDivider: {
    marginTop: '14px',
    marginRight: '20px',
    marginLeft: '20px'
  },
  popUpHeaderTitle: {
    textAlign: 'center',
    fontSize: '12px',
    lineHeight: '20px',
    fontWeight: '700'
  },
  titleContainer: {
    maxHeight: '55px',
    overflow: 'auto'
  },
  popUpHeader: {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    maxHeight: '30px'
  },
  popUpContainer: {
    marginTop: '20px',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  listItemText: {
    width: '90%',
    fontSize: '12px',
    lineHeight: '19px',
    fontFamily: 'Rubik',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: '1',
    WebkitBoxOrient: 'vertical'
  },
  listItemContainer: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: theme.colors.gray3,
    justifyContent: 'space-between',
    height: '27px',
    marginTop: '3.5px',
    marginBottom: '3.5px',
    alignItems: 'center',
    paddingLeft: '15px',
    paddingRight: '10px',
    borderRadius: '4px'
  },
  chipContainer: {
    display: 'flex',
    paddingTop: '10px'
  },
  chipStyles: {
    marginBottom: '5px',
    fontSize: '12px',
    borderColor: theme.colors.iconBlue,
    color: theme.colors.iconBlue,
    fontWeight: '700',
    lineHeight: '30px',
    fontFamily: 'Rubik'
  },
  selectButton: {
    fontSize: '14px',
    ':hover': {
      backgroundColor: theme.colors.white
    },
    textTransform: 'none',
    color: theme.colors.iconBlue
  }
}))

export const photosElementStyles = makeStyles()(theme => ({
  inImagePlaceholderText: {
    position: 'absolute',
    top: '70%',
    left: '7%',
    fontSize: '8px',
    fontWeight: '700',
    color: theme.colors.redError
  },
  addButton: {
    border: `1px solid ${theme.colors.iconBlue}`,
    width: '100%',
    paddingTop: '6px',
    paddingBottom: '6px',
    borderRadius: '8px'
  },
  addButtonText: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '10px',
    color: theme.colors.iconBlue
  },
  addButtonTextRed: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '10px',
    color: theme.colors.redError
  },
  menuButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start'
  },
  menuItems: {
    width: '297px',
    fontSize: '12px'
  },
  buttonImagePlaceholder: {
    alignItems: 'flex-start',
    justifyContent: 'left',
    '&:hover': {
      backgroundColor: theme.colors.white
    }
  },
  buttonStyles: {
    textTransform: 'none',
    fontSize: '12px',
    fontWeight: '700',
    fontFamily: 'Rubik',
    borderRadius: '18px'
  },
  addButtonContainer: {
    paddingTop: '30px',
    display: 'flex',
    justifyContent: 'center'
  },
  chipStyles: {
    minWidth: '70px',
    fontSize: '12px',
    borderColor: theme.colors.iconBlue,
    color: theme.colors.iconBlue,
    fontWeight: '700',
    lineHeight: '30px',
    fontFamily: 'Rubik'
  },
  imagesContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5em',
    paddingTop: '20px'
  },
  attachmentsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5em'
  },
  imagePlaceholder: {
    width: '40%'
  }
}))

export const attachmentsElementStyles = makeStyles()(theme => ({
  inImagePlaceholderText: {
    position: 'absolute',
    top: '70%',
    left: '13%',
    fontSize: '8px',
    fontWeight: '700',
    color: theme.colors.redError
  },
  addButton: {
    border: `1px solid ${theme.colors.iconBlue}`,
    width: '100%',
    paddingTop: '5px',
    paddingBottom: '5px',
    borderRadius: '8px'
  },
  addButtonText: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '10px',
    color: theme.colors.iconBlue
  },
  addButtonTextRed: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '10px',
    color: theme.colors.redError
  },
  menuButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start'
  },
  menuItems: {
    width: '297px',
    fontSize: '12px'
  },
  buttonImagePlaceholder: {
    alignItems: 'flex-start',
    justifyContent: 'left',
    '&:hover': {
      backgroundColor: theme.colors.white
    }
  },
  buttonStyles: {
    textTransform: 'none',
    fontSize: '12px',
    fontWeight: '700',
    fontFamily: 'Rubik',
    borderRadius: '18px'
  },
  addButtonContainer: {
    paddingTop: '30px',
    display: 'flex',
    justifyContent: 'center'
  },
  chipStyles: {
    minWidth: '70px',
    fontSize: '12px',
    borderColor: theme.colors.iconBlue,
    color: theme.colors.iconBlue,
    fontWeight: '700',
    lineHeight: '30px',
    fontFamily: 'Rubik'
  },
  imagesContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5em',
    paddingTop: '20px'
  },
  attachmentsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5em'
  },
  imagePlaceholder: {
    width: '40%'
  }
}))

export const signatureElementStyles = makeStyles()(theme => ({
  signatureImage: {
    width: '100%'
  },
  textInput: {
    borderRadius: '8px',
    background: theme.colors.lightBlue2,
    fontSize: '12px',
    paddingLeft: '5px',
    paddingTop: '10px',
    paddingBottom: '8px'
  },
  placeholderText: {
    fontSize: '14px',
    paddingTop: '5px',
    color: theme.colors.gray4
  },
  placeholderContainer: {
    justifyContent: 'left',
    alignItems: 'flex-start',
    textTransform: 'none',
    marginTop: '10px',
    borderWidth: 0,
    borderRadius: '8px',
    marginBottom: '8px',
    height: '100px',
    background: theme.colors.lightBlue2
  }
}))

export const helpfulHintPopUpStyles = makeStyles()(theme => ({
  textContainer: {
    paddingHorizontal: '20px',
    paddingTop: '21px',
    paddingBottom: '23px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  titleText: {
    fontSize: '26px',
    fontWeight: '800',
    fontFamily: 'Avenir',
    marginBottom: '13px'
  },
  hintText: {
    fontSize: '14px',
    textAlign: 'center',
    lineHeight: '22px',
    color: theme.colors.textButton,
    fontWeight: '800'
  },
  buttonContainer: {
    width: '100%',
    paddingRight: '10px',
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  chipStyles: {
    fontSize: '12px',
    fontWeight: '700',
    width: '100px',
    height: '40px',
    borderRadius: '20px'
  }
}))

export const singleLineItemStyles = makeStyles()(theme => ({
  rowItem: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: '10px'
  },
  dividerStyle: {
    backgroundColor: theme.colors.textButton,
    borderRightWidth: '0.2px',
    marginRight: '10px',
    marginLeft: '5px'
  },
  dividerContainer: {
    width: '1px',
    justifyContent: 'center',
    display: 'flex'
  },
  divider: {
    backgroundColor: theme.colors.textButton,
    width: '0.2px'
  },
  description: {
    '& .MuiInputBase-root': {
      height: '50px', // Change height here
      backgroundColor: theme.colors.grey_2, // Change background color here
      fontSize: '12px'
    }
  },
  deleteButton: {
    backgroundColor: theme.colors.deleteRed,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '5px 0px 0px 5px',
    '&:hover': {
      backgroundColor: theme.colors.deleteRed
    }
  },
  icon: {
    color: theme.colors.white,
    fontSize: '15px'
  }
}))

export const lineItemsStyles = makeStyles()(theme => ({
  dashedDividerContainer: {
    marginRight: '16px',
    marginLeft: '16px',
    marginBottom: '10px'
  },
  customDivider: {
    border: 'none',
    borderTop: `2px dashed ${theme.colors.grayDivider}`
  },
  subtotalContainer: {
    textAlign: 'center'
  },
  shadow: {
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    padding: '10px 5px',
    borderRadius: '8px',
    background: theme.colors.white
  },
  container: {
    width: '100%'
  },
  plusIcon: {
    fontSize: '5px',
    color: theme.colors.textButton
  },
  addButton: {
    textTransform: 'none',
    color: theme.colors.iconBlue,
    borderRadius: '20px', // Adjust the value as needed
    border: '1px solid',
    fontSize: '14px',
    fontWeight: '500',
    padding: '5px 15px 5px 15px'
  },
  separation: {
    height: '10px'
  },
  subTotalValue: {
    fontSize: '18px'
  },
  subTotalLabel: {
    fontSize: '12px',
    color: theme.colors.grayAlt
  },
  previewSubtotalValue: {
    fontSize: '18px',
    fontWeight: '600',
    fontFamily: 'Rubik'
  },
  divider: {
    marginTop: '15px',
    marginBottom: '-15px',
    background: theme.colors.gray,
    height: '0.5px'
  }
}))

export const lineItemInputStyles = makeStyles()(theme => ({
  inputComponetStyle: {
    '& .MuiInputBase-root': {
      height: '30px', // Change height here
      backgroundColor: theme.colors.grey_2, // Change background color here
      fontSize: '12px',
      padding: '0px'
    },
    '& .MuiInputBase-input::placeholder': {
      color: theme.colors.textGray // Change placeholder color here
    },
    '& .MuiInputBase-input': {
      overflow: 'hidden', // Hide overflow text
      textOverflow: 'ellipsis' // Show ellipsis for overflow text
    }
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  inputComponentContainer: {
    marginBottom: '5px'
  },
  required: {
    color: theme.colors.redError
  }
}))

export const singleMaterialStyles = makeStyles()(theme => ({
  dividerContainer: {
    width: '1px',
    justifyContent: 'center',
    display: 'flex'
  },
  divider: {
    backgroundColor: theme.colors.textButton,
    width: '0.2px'
  },
  description: {
    '& .MuiInputBase-root': {
      height: '50px', // Change height here
      backgroundColor: theme.colors.grey_2, // Change background color here
      fontSize: '12px'
    }
  },
  deleteButton: {
    backgroundColor: theme.colors.deleteRed,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '5px 0px 0px 5px',
    '&:hover': {
      backgroundColor: theme.colors.deleteRed
    }
  },
  icon: {
    color: theme.colors.white,
    fontSize: '15px'
  }
}))

export const materialsStyles = makeStyles()(theme => ({
  dashedDividerContainer: {
    marginRight: '16px',
    marginLeft: '16px',
    marginBottom: '10px'
  },
  customDivider: {
    border: 'none',
    borderTop: `2px dashed ${theme.colors.grayDivider}`
  },
  subtotalContainer: {
    textAlign: 'center'
  },
  shadow: {
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    padding: '10px 5px',
    borderRadius: '8px',
    background: theme.colors.white
  },
  container: {
    width: '100%'
  },
  plusIcon: {
    fontSize: '5px',
    color: theme.colors.textButton
  },
  addButton: {
    textTransform: 'none',
    color: theme.colors.iconBlue,
    borderRadius: '20px', // Adjust the value as needed
    border: '1px solid',
    fontSize: '12px',
    fontWeight: '500'
  },
  separation: {
    height: '10px'
  },
  subTotalValue: {
    fontSize: '18px'
  },
  subTotalLabel: {
    fontSize: '12px',
    color: theme.colors.grayAlt
  },
  previewSubtotalValue: {
    fontSize: '18px',
    fontWeight: '600',
    fontFamily: 'Rubik'
  },
  divider: {
    marginTop: '15px',
    marginBottom: '-15px',
    background: theme.colors.gray,
    height: '0.5px'
  }
}))

export const materialInputStyles = makeStyles()(theme => ({
  inputComponetStyle: {
    '& .MuiInputBase-root': {
      height: '30px', // Change height here
      backgroundColor: theme.colors.grey_2, // Change background color here
      fontSize: '12px',
      padding: '0px'
    },
    '& .MuiInputBase-input::placeholder': {
      color: theme.colors.textGray // Change placeholder color here
    },
    '& .MuiInputBase-input': {
      overflow: 'hidden', // Hide overflow text
      textOverflow: 'ellipsis' // Show ellipsis for overflow text
    }
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  inputComponentContainer: {
    marginBottom: '5px'
  },
  required: {
    color: theme.colors.redError
  }
}))

export const authorizationFieldStyles = makeStyles()(theme => ({
  botttomSpace: {
    height: '30px'
  },
  divider: {
    background: theme.colors.gray,
    height: '0.5px',
    marginTop: '-5px',
    marginBottom: '15px'
  },
  signatureImage: {
    width: '100%'
  },
  asterisk: {
    fontSize: '10px',
    fontWeight: '700',
    fontFamily: 'Rubik',
    letterSpacing: '1px',
    color: theme.colors.redError
  },
  subtitleContainer: {
    display: 'flex',
    flexDirection: 'row'
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px'
  },
  textInput: {
    borderRadius: '8px',
    fontSize: '14px',
    paddingBottom: '8px',
    color: theme.colors.textButton
  },
  placeholderText: {
    fontSize: '14px',
    paddingTop: '5px',
    color: theme.colors.gray4
  },
  placeholderContainer: {
    justifyContent: 'left',
    alignItems: 'flex-start',
    textTransform: 'none',
    marginTop: '5px',
    borderWidth: 0,
    borderRadius: '8px',
    height: '80px'
  },
  fileIcon: {
    marginRight: '10px'
  },
  title: {
    fontFamily: 'Rubik',
    fontSize: '18px',
    fontWeight: '500',
    color: theme.colors.text
  },
  subTitle: {
    fontSize: '10px',
    fontWeight: '700',
    fontFamily: 'Rubik',
    letterSpacing: '1px',
    color: theme.colors.text
  },
  paymentTermsContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  authorizationToProceedContainer: {
    paddingTop: '10px',
    display: 'flex'
  },
  selectButtonText: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '10px',
    color: theme.colors.iconBlue
  },
  selectButtonTextAlt: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '10px',
    color: theme.colors.text
  },
  selectButtonAlt: {
    textTransform: 'none',
    border: `1px solid ${theme.colors.iconBlue}`,
    width: '100%',
    paddingTop: '8px',
    paddingBottom: '8px',
    borderRadius: '8px'
  },
  buttonSeparator: {
    height: '10px'
  }
}))

export const eaServicesComponentStyles = makeStyles()(theme => ({
  totalAmountTitle: {
    fontSize: '12px',
    fontWeight: '500',
    color: theme.colors.textButton,
    fontFamily: 'Rubik'
  },
  totalAmountValue: {
    fontSize: '20px',
    fontWeight: '600',
    color: theme.colors.text,
    fontFamily: 'Rubik'
  }
}))

export const serviceChecklistStyles = makeStyles()(theme => ({
  card: {
    backgroundColor: theme.colors.backdropColor,
    borderRadius: '12px'
  },
  itemRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: `1px solid ${theme.colors.gray5}`,
    borderRadius: '10px',
    padding: '16px',
    marginBottom: '12px',
    cursor: 'pointer',
    transition: 'background-color 0.2s'
  },
  itemRowDisabled: {
    cursor: 'default',
    opacity: 0.6
  },
  itemLeft: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  indexText: {
    fontSize: '16px',
    color: theme.colors.textButton,
    marginRight: '8px',
    fontFamily: 'Rubik'
  },
  itemText: {
    fontFamily: 'Rubik',
    fontSize: '14px',
    color: theme.colors.black1,
    fontWeight: '400'
  },
  checkbox: {
    width: '24px',
    height: '24px',
    borderRadius: '6px',
    border: `1px solid ${theme.colors.iconBlue}`, // ADFTC_BLUE1 equivalent
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s'
  },
  checkboxChecked: {
    backgroundColor: 'transparent'
  },
  separator: {
    borderBottom: `1px solid ${theme.colors.gray}`,
    margin: '16px 0'
  }
}))
